import { render, staticRenderFns } from "./WorkspacePhotoTips.vue?vue&type=template&id=51db4341&scoped=true&"
import script from "./WorkspacePhotoTips.vue?vue&type=script&lang=js&"
export * from "./WorkspacePhotoTips.vue?vue&type=script&lang=js&"
import style0 from "./WorkspacePhotoTips.vue?vue&type=style&index=0&id=51db4341&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51db4341",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51db4341')) {
      api.createRecord('51db4341', component.options)
    } else {
      api.reload('51db4341', component.options)
    }
    module.hot.accept("./WorkspacePhotoTips.vue?vue&type=template&id=51db4341&scoped=true&", function () {
      api.rerender('51db4341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspacePhotoTips.vue"
export default component.exports